import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CoachAdminDto } from "../../../models/coach/dto/coach-admin.dto";

export const GET_COACH_ADMIN_QUERY_KEY = (id: string) => ['coach', id, 'admin'];

/**
 * MYS-75 (D1) — the coach with every contact field, from the admin-only
 * `GET coachs/:id/admin`. `enabled` must be false for anyone who is not an
 * organization admin: the route 403s them, and a coach opening their own row
 * reads the public `useGetCoach` only.
 */
export const useGetCoachAdmin = (id: string, enabled: boolean) => {
    const apiClient = useApiClient();
    return useQuery({
        enabled: Boolean(id) && enabled,
        queryKey: GET_COACH_ADMIN_QUERY_KEY(id),
        queryFn: () => apiClient.fetchApi<CoachAdminDto, {}>({ method: 'GET', endpoint: `coachs/${id}/admin` })
    });
};
